if (!customElements.get('sticky-atc')) {

class StickyATC extends HTMLElement {

  constructor() {

    super({
      name: 'Sticky ATC',
      version: '2.0.0'
    })
  }

  connectedCallback() {

    this.stickyATCUpper = document.querySelector('.section-main-product')
    this.alwaysStickyMobile = this.dataset.alwaysStickyMobile;

    if (!this.stickyATCUpper && !this.alwaysStickyMobile) return;

    this.button = this.querySelector('[data-sticky-atc-btn]')
    this.mobileButton = this.querySelector('.mobile-trigger button');
    this.colorSelector = this.querySelector('.product__color-selector')
    this.variantSelector = this.querySelector('.product__variant-selector')

    document.documentElement.style.setProperty('--footer-offset', `${this.offsetHeight}px`);

    if (!this.alwaysStickyMobile) {
      new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2  }).observe(this.stickyATCUpper)
    } else {
      this.handleAlwaysSticky();
    }

    // Listeners
    this.colorSelectorDrawerListener()
    this.variantSelectorListener()

    if(this.button) {
      this.button.addEventListener('click', this.onClickHandler.bind(this));
    }

    if(this.mobileButton) {
      this.mobileButton.addEventListener('click', (event) => {
        this.onClickHandlerMobile(event);
        this.onClickHandler(event);
      });
    }
  }

  disconnectedCallback() {

    if (!this.stickyATCUpper && !this.alwaysSticky) return;

    // disconnect IntersectionObserver
    const observer = new IntersectionObserver(this.handleUpperIntersect.bind(this), { threshold: 0.2  })
    observer.unobserve(this.stickyATCUpper)
  }

  handleAlwaysSticky() {
    document.querySelector('sticky-atc').style.transform = "translateY(0)"
    this.variantSelector?.classList.remove('active')
    this.colorSelector?.classList.remove('active')
  }

  handleUpperIntersect(entries, observer) {

    this.colorSelector = this.querySelector('.product__color-selector')
    this.variantSelector = this.querySelector('.product__variant-selector')

    entries.forEach((entry) => {

      if (entry.isIntersecting) {
        // hide when scrolling up
        document.querySelector('sticky-atc').style.transform = "translateY(calc(100% + var(--layout-space-24)))"
        this.variantSelector?.classList.remove('active')
        this.colorSelector?.classList.remove('active')
      }else{
        // show when scrolling down
        document.querySelector('sticky-atc').style.transform = "translateY(0)"
        this.variantSelector?.classList.remove('active')
        this.colorSelector?.classList.remove('active')
      }
    })
  }


  colorSelectorDrawerListener() {
    this.colorSelector?.querySelector('.product__color-selector--wrapper').addEventListener('click', () => {
      this.colorSelector.classList.toggle('active')
      this.variantSelector?.classList.remove('active')
    })
  }

  variantSelectorListener() {
    this.variantSelector?.querySelector('.product__variant-selector--wrapper').addEventListener('click', () => {
      this.variantSelector.classList.toggle('active')
      this.colorSelector?.classList.remove('active')
    })
  }


  onClickHandler(event) {
    event.preventDefault();
    var mainAtc = document.querySelector('product-form .product-form__submit');
    if(mainAtc){
      mainAtc.click();
    }
  }

  onClickHandlerMobile(event) {
    event.preventDefault();
    // Scroll to top on mobile devices
    if (window.innerWidth < 750) {
      window.scroll({ top: 0, behavior: 'smooth' });
    }
  }

}

customElements.define('sticky-atc', StickyATC);

}
